import { Field, Input } from "@fluentui/react-components";
import { PropsWithChildren, ReactElement } from "react";
import {
    Control,
    Controller,
    FieldError,
    FieldValues,
    Path,
    RegisterOptions
} from "react-hook-form";

interface Props<T extends FieldValues> {
    name: Path<T>;
    label: string;
    required?: boolean;
    control: Control<T, any>;
    readonly?: boolean;
    rules?: Omit<RegisterOptions<T, Path<T>>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"> | undefined;
    error?: FieldError | undefined;
    type?:
    | "number"
    | "search"
    | "text"
    | "time"
    | "email"
    | "password"
    | "tel"
    | "url"
    | "date"
    | "datetime-local"
    | "month"
    | "week"
    | undefined;
    autoComplete?: string;
    disabled?: boolean;
    size?: "small" | "medium" | "large";
    contentBefore?: ReactElement;
}

const FormInput = <T extends FieldValues>(
    props: PropsWithChildren<Props<T>>
): ReactElement | null => {
    return (
        <Controller
            name={props.name}
            control={props.control}
            rules={props.rules}
            render={({ field }) => {
                return (
                    <Field
                        size={props.size || "medium"}
                        label={props.label}
                        required={props.required}
                        validationMessage={props.error?.message}
                        validationState={props.error ? "error" : "success"}
                    >
                        <Input
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            
                            contentBefore={props.contentBefore}
                            type={props.type || "text"}
                            readOnly={props.readonly}
                            appearance={
                                props.readonly ? "underline" : "outline"
                            }
                            autoComplete={props.autoComplete}
                            disabled={props.disabled}
                            size={props.size || "medium"}
                        />
                    </Field>
                );
            }}
        ></Controller>
    );
};

export default FormInput;
